import { Fragment } from 'react';
import {
    Datagrid,
    DateField,
    DateInput,
    TextField,
    EmailField,
    TextInput,
    SelectInput,
    Filter,
    BulkDeleteButton,
    BulkExportButton,
    BooleanField,
    PasswordInput,
    required
} from 'react-admin';
import { List, ListActions } from '@react-admin/ra-enterprise';
import { CustomBreadcrumb } from './CustomBreadcrumb';
import CustomPagination from './CustomPagination';
import { makeStyles } from '@material-ui/core/styles';
import { EditableDatagrid, RowForm } from '@react-admin/ra-editable-datagrid';


function idRoleAllow(resource_name, action_name) {
    let return_value = 'no';
    let login_role = localStorage.getItem('role');
    if (login_role == 'admin') {
        return 'ok';
    }
    let allpermission = JSON.parse(localStorage.getItem("roles"));
    let roledata = [];
    if (login_role == 'accountant') {
        roledata = allpermission.accountant;
    }
    if (login_role == 'auditor') {
        roledata = allpermission.auditor;
    }
    if (login_role == 'editor') {
        roledata = allpermission.editor;
    }
    roledata.map((role_row, index) => {
        if ((role_row.resource == resource_name) && (role_row.action.indexOf(action_name) > -1)) {
            return_value = 'ok';
        }
    });
    return return_value;
}

const DepositBulkActionButtons = ({ basePath }) => (
    <Fragment>
        {(idRoleAllow('deposits', 'export') == 'ok') ?
            <BulkExportButton /> : ''}
        {/* {(idRoleAllow('deposits', 'delete') == 'ok') ?
            <BulkDeleteButton basePath={basePath} /> : ''} */}
    </Fragment>
);

const DepositEcurrencyListActions = (props) => (
    <ListActions  {...props} breadcrumb={<CustomBreadcrumb variant="actions" />} exporter={(idRoleAllow('deposits', 'export') == 'ok') ? true : false} />
)

const status_choices = [
    { id: true, name: 'Active' },
    { id: false, name: 'Inactive' }];

const coin_choices = [{ id: 'PAYEER', name: 'Payeer' }];

const DepositECurrencyForm = props => (
    <RowForm {...props}>
        <TextField source="coin_name_alter" label="Currency name" />
        <TextField source="address" label="Wallet" validate={required()} />
        <PasswordInput source="password_raw" label="API password" validate={required()} />
        <DateField source="created_at" label="Created at" showTime/>
    </RowForm>
);

const DepositList = (props) => {
    return (
        <List
            {...props}
            // hasCreate
            sort={{ field: 'id', order: 'ASC' }}
            actions={<DepositEcurrencyListActions />}
            bulkActionButtons={<DepositBulkActionButtons />}
            pagination={<CustomPagination />}
            title={'Deposit payeer'}
        >
            <EditableDatagrid
                className="lastOrdersColumn"
                rowClick="edit"
                noDelete="true"
                createForm={<DepositECurrencyForm />}
                editForm={<DepositECurrencyForm />}
            >
                <TextField style={{ textTransform: 'capitalize' }} source="coin_name_alter" label="Currency name" />
                <TextField source="address" label="Wallet" />
                <TextField source="password" label="API password" />
                <DateField source="created_at" label="Created at" showTime />
            </EditableDatagrid>
        </List>
    )
};
export default DepositList;